import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import nashville__asset from "@/assets/restore/locations/nashville.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Nashville",
    serviceArea: "nashville",
    address: "3200 West End Ave, Suite 500",
    img: nashville__asset.url,
    mapUrl: map("3200 West End Ave Nashville TN"),
    to: "/locations/tennessee/nashville/",
  },
];

export const Route = createFileRoute("/locations/tennessee/")({
  head: () => ({
    meta: [
      { title: "RESTORE Hair | Tennessee Hair Transplants + Hair Restoration" },
      {
        name: "description",
        content:
          "Get your hair back and RESTORE your confidence in Tennessee with RESTORE Hair Transplants, offering FUE & No Shave Hair Restoration. Get a free consult today!",
      },
      { property: "og:title", content: "Tennessee Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Nashville, Tennessee and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/tennessee/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/tennessee/" }],
  }),
  component: () => <StateLocationsHub stateName="Tennessee" h1="Tennessee Hair Transplants" cities={cities} />,
});